<template lang="pug">
    ib-application(layout="full", :translations="translations")
        EventsCalendarView
</template>

<script>
    import EventsCalendarView from './view/EventsCalendarView.vue'

    export default {
        name: 'index',
        components: {
            EventsCalendarView
        },

        data() {
            return {
                translations: _i18n.translations
            };
        },

        methods: {
        }
    }
</script>

<style lang="less">
    .myapp {
        .thing {
            opacity: .5;
        }
    }
</style>
